import { BorderStyleEnum } from 'common/types/styleTypes'

export const parseBorderCssProperty = (property: string) => {
  const borderRegex = /^([0-9]+)px ([a-zA-Z]+) ([#\da-zA-Z]+)$/
  const match = property.match(borderRegex)

  if (match) {
    return {
      width: Number.parseInt(match[1], 10),
      style: match[2] as BorderStyleEnum,
      color: match[3],
    }
  } else {
    return null
  }
}
